import axios from 'axios';

import { RAYCHAT_FAQ_API_URL } from 'utils/constants';

let token = localStorage.getItem('token');

const axiosInstance = axios.create({
  baseURL: RAYCHAT_FAQ_API_URL,
  // withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
    Authorization: token,
  },
});

export const handleGetKnowledgeBaseData = async (channelId) => {
  const response = await axiosInstance.get(`/faq/profile/${channelId}`);

  return response.data;
};

export const handlePutKnowledgeBaseData = async (channelId, data) => {
  const response = await axiosInstance.put(`/faq/profile/${channelId}`, data);

  return response.data;
};
